
import { fiqh101Questions } from './questions/fiqh101';
import { fiqh101QuestionsExtra } from './questions/fiqh101-extra';
import { fiqh101QuestionsExtra3 } from './questions/fiqh101-comprehensive';
import { fiqh101QuestionsAdditional } from './questions/fiqh101-additional';
import { qur101Questions } from './questions/qur101';
import { qur101RevelationQuestions } from './questions/qur101-revelation';
import { qur101CharacteristicsQuestions } from './questions/qur101-characteristics';
import { qur101RevelationOrderQuestions } from './questions/qur101-revelation-order';
import { qur101SababNuzulQuestions } from './questions/qur101-sabab-nuzul';
import { qur101PreservationQuestions } from './questions/qur101-preservation';
import { qur101StandardizationQuestions } from './questions/qur101-standardization';
import { qur101AhrufQuestions } from './questions/qur101-ahruf';
import { qur101AbrogationQuestions } from './questions/qur101-abrogation';
import { qur101TafsirQuestions } from './questions/qur101-tafsir';
import { qur101TafsirTypesQuestions } from './questions/qur101-tafsir-types';
import { qur101AdditionalQuestions } from './questions/qur101-additional';
import { taj101IntroductionQuestions } from './questions/taj101-introduction';
import { taj101VowelsQuestions } from './questions/taj101-vowels';
import { taj101IstiadhaBasmalahQuestions } from './questions/taj101-istiadha-basmalah';
import { taj101MakharijQuestions } from './questions/taj101-makharij';
import { taj101SifatQuestions } from './questions/taj101-sifat';
import { taj101TafkhimTarqiqQuestions } from './questions/taj101-tafkhim-tarqiq';
import { taj101NunMimQuestions } from './questions/taj101-nun-mim';
import { taj101MaddQuestions } from './questions/taj101-madd';
import { taj101WaqfQuestions } from './questions/taj101-waqf';
import { taj101PracticalExamplesQuestions } from './questions/taj101-practical-examples';
import { taj101ExceptionsQuestions } from './questions/taj101-exceptions';
import { taj101CommonMistakesQuestions } from './questions/taj101-common-mistakes';
import { taj101AdditionalQuestions } from './questions/taj101-additional';

export const questions = [
  ...fiqh101Questions,
  ...fiqh101QuestionsExtra,
  ...fiqh101QuestionsExtra3,
  ...fiqh101QuestionsAdditional,
  ...qur101Questions,
  ...qur101RevelationQuestions,
  ...qur101CharacteristicsQuestions,
  ...qur101RevelationOrderQuestions,
  ...qur101SababNuzulQuestions,
  ...qur101PreservationQuestions,
  ...qur101StandardizationQuestions,
  ...qur101AhrufQuestions,
  ...qur101AbrogationQuestions,
  ...qur101TafsirQuestions,
  ...qur101TafsirTypesQuestions,
  ...qur101AdditionalQuestions,
  ...taj101IntroductionQuestions,
  ...taj101VowelsQuestions,
  ...taj101IstiadhaBasmalahQuestions,
  ...taj101MakharijQuestions,
  ...taj101SifatQuestions,
  ...taj101TafkhimTarqiqQuestions,
  ...taj101NunMimQuestions,
  ...taj101MaddQuestions,
  ...taj101WaqfQuestions,
  ...taj101PracticalExamplesQuestions,
  ...taj101ExceptionsQuestions,
  ...taj101CommonMistakesQuestions,
  ...taj101AdditionalQuestions
];
